export default __webpack_public_path__ + "static/media/feature6.73beaa87.png";